import React from 'react';
import { useFormik } from 'formik';
import Button from "../../components/button/Button"; 
import * as Yup from 'yup';
import {
  TextField,
  Container,
  Grid,
  Paper,
} from '@mui/material';

const ContactForm = (props) => {
  const theme = props.theme;

  const formik = useFormik({
    initialValues: {
      fullName: '',
      email: '',
      phone: '',
      message: '',
    },
    validationSchema: Yup.object({
      fullName: Yup.string().required('Required'),
      email: Yup.string().email('Invalid email address').required('Required'),
      phone: Yup.string()
        .required('Required')
        .matches(/^\d+$/, 'Phone number is not valid')
        .min(10, 'Must be at least 10 digits'),
      message: Yup.string().required('Required'),
    }),
    onSubmit: (values) => {
      const { fullName, email, phone, message } = values;
      const whatsappMessage = `Full Name: ${encodeURIComponent(fullName)}%0A` +
        `Email: ${encodeURIComponent(email)}%0A` +
        `Phone: ${encodeURIComponent(phone)}%0A` +
        `Message: ${encodeURIComponent(message)}`;
      
      const whatsappURL = `https://wa.me/8479089674?text=${whatsappMessage}`;
      window.open(whatsappURL, '_blank').focus();
      formik.resetForm(); 
    },
  });

  return (
    <Container component="main" maxWidth="xs">
      <Paper elevation={3} style={{ padding: 20, marginTop: 20 }}>
        <form onSubmit={formik.handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                id="fullName"
                name="fullName"
                label="Full Name"
                value={formik.values.fullName}
                onChange={formik.handleChange}
                error={formik.touched.fullName && Boolean(formik.errors.fullName)}
                helperText={formik.touched.fullName && formik.errors.fullName}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                id="email"
                name="email"
                label="Email"
                value={formik.values.email}
                onChange={formik.handleChange}
                error={formik.touched.email && Boolean(formik.errors.email)}
                helperText={formik.touched.email && formik.errors.email}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                id="phone"
                name="phone"
                label="Phone"
                value={formik.values.phone}
                onChange={formik.handleChange}
                error={formik.touched.phone && Boolean(formik.errors.phone)}
                helperText={formik.touched.phone && formik.errors.phone}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                id="message"
                name="message"
                label="Message"
                multiline
                rows={4}
                value={formik.values.message}
                onChange={formik.handleChange}
                error={formik.touched.message && Boolean(formik.errors.message)}
                helperText={formik.touched.message && formik.errors.message}
              />
            </Grid>
          </Grid>
          <div className="blogsite-btn-div" style={{ marginTop: 20 }}>
            <Button 
              onClick={formik.handleSubmit} 
              text="Send message" 
              newTab={true} 
              theme={theme} 
            />
          </div>
        </form>
      </Paper>
    </Container>
  );
};

export default ContactForm;
